import Pics from './pics';

const customWidgets = [{
  component: Pics,
  widgetType: 105
}];

export default customWidgets;
